import { graphql } from 'react-relay';

export const pageInfoFragment = graphql`
    fragment pageInfoFragment on PageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
    }
`;
